import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon, ChevronsLeftIcon, ChevronsRightIcon } from './Icons';

const PAGE_SIZE_OPTIONS = [20, 50, 100];

function Pagination({ page, totalPages, onPageChange, pageSize, onPageSizeChange, totalItems }) {
  if (totalItems === 0) return null;

  return (
    <div className="pagination">
      <label className="pagination-size">
        Rows per page
        <select value={pageSize} onChange={(e) => onPageSizeChange(Number(e.target.value))}>
          {PAGE_SIZE_OPTIONS.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
      </label>

      {totalPages > 1 && (
        <div className="pagination-controls">
          <button disabled={page === 1} onClick={() => onPageChange(1)} aria-label="First page">
            <ChevronsLeftIcon width={16} height={16} />
          </button>
          <button disabled={page === 1} onClick={() => onPageChange(page - 1)} aria-label="Previous page">
            <ChevronLeftIcon width={16} height={16} />
          </button>
          <span className="pagination-status">
            Page {page} of {totalPages}
          </span>
          <button disabled={page === totalPages} onClick={() => onPageChange(page + 1)} aria-label="Next page">
            <ChevronRightIcon width={16} height={16} />
          </button>
          <button disabled={page === totalPages} onClick={() => onPageChange(totalPages)} aria-label="Last page">
            <ChevronsRightIcon width={16} height={16} />
          </button>
        </div>
      )}
    </div>
  );
}

export default Pagination;
